export enum UserArticlesSort {
	NewestOldest = 0,
	OldestNewest = 1,
	LikesCountDesc = 2,
}

export enum WardrobeItemsSort {
	NewestOldest = 0,
	OldestNewest = 1,
	//NameAsc,
	//LikesCountDesc,
	//ViewsCountDesc
}

export enum ProductsSort {
	NewestOldest = 0,
	OldestNewest = 1,
	PriceHighToLow = 2,
	PriceLowToHigh = 3,
	Name = 4,
	NameDesc = 5,
}

export enum OutfitsSort {
	NewestOldest = 0,
	OldestNewest = 1,
}

export enum UserLikedItemsSort {
	NameAsc,
	LikesCountDesc,
}

export enum AdminArticlesSort {
	AddedDateDesc,
	AddedDateAsc,
}

export enum AdminShopsSort {
	AddedDateDesc,
	AddedDateAsc,
}

export enum AdminMenuItemsSort {
	ReleaseDateDesc,
	ReleaseDateAsc,
	ExpireDateDesc,
	ExpireDateAsc,
}

export enum JobBoardItemsSort {
	NewestOldest = 0,
	OldestNewest = 1,
	PriceHighToLow = 2,
	PriceLowToHigh = 3,
	MostViewed = 4,
}
